import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import * as AppConstants from "../context/AppConstants";

const styles = StyleSheet.create({
  mainWrapper: {
    flexDirection: "row",
  },
  innerWrapper: {
    backgroundColor: "#e3e3e3",
    borderWidth: 1,
    borderColor: "#827b85",
    borderRadius: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    padding: 5,
    paddingLeft: 10,
  },
  closePressable: {
    paddingRight: 5,
  },
});

export function CustomChip({ onClose, style, ...props }) {
  let innerWrapperStyles = [styles.innerWrapper];
  if (style) {
    innerWrapperStyles.push(style);
  }

  return (
    <View style={styles.mainWrapper}>
      <View style={innerWrapperStyles}>
        <Text style={styles.text} {...props} />
        {
          onClose ?
              <Pressable style={styles.closePressable} onPress={onClose}>
                <Image source={require('../../assets/clear-grey-18.png')} style={AppConstants.STYLES.image18x18} />
              </Pressable>
            :
              null
        }
      </View>
    </View>
  );
}
